import { combineReducers, configureStore } from '@reduxjs/toolkit';
import exchangeReducer from '@shared/store/exchangeSlice';
import { logout } from '@shared/store/exchangeSlice';
import homePageReducer from '@shared/store/homePageSlice';
import inventoryReducer from '@shared/store/inventorySlice';
import partnerReducer from '@shared/store/partnerSlice';
import userManagementReducer from '@shared/store/userManagementSlice';

const appReducer = combineReducers({
  exchange: exchangeReducer,
  homePage: homePageReducer,
  inventory: inventoryReducer,
  partner: partnerReducer,
  userManagement: userManagementReducer
});

const rootReducer: typeof appReducer = (state, action) => {
  if (action.type === logout.type) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
